'use client';

import { useEffect } from 'react';

const ErudaInit = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.has('debug') &&
      import('eruda').then((eruda) => eruda.default.init());
  }, []);
  return null;
};

export default ErudaInit;
